import { RootDispatch } from "redux/rootReducer";
import { load, loadFail, loadSuccess } from "./yieldHistoryActions";
import * as request from "utility/request";
import { YieldHistory } from "types/YieldHistory";
import { AssetClass } from "types/AssetClass";

const apiUrl = process.env.REACT_APP_API_URL;

export const loadYieldHistories = (
  reportControlId: string,
  reportDate: string,
  showIndex: boolean
) => {
  return async (dispatch: RootDispatch) => {
    dispatch(load("all"));

    try {
      const res = await request.getResponseJson<YieldHistory[]>(
        `${apiUrl}/api/yieldhistory?showIndex=${showIndex}&reportControlId=${reportControlId}&reportDate=${reportDate}`
      );
      dispatch(loadSuccess("all", res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail("all", error));
    }
  };
};

export const loadYieldHistoriesByAssetClass = (
  assetClass: AssetClass,
  reportControlId: string,
  reportDate: string,
  showIndex: boolean
) => {
  const assetClassString = AssetClass[assetClass] as keyof typeof AssetClass;
  return async (dispatch: RootDispatch) => {
    dispatch(load(assetClassString));

    try {
      const res = await request.getResponseJson<YieldHistory[]>(
        `${apiUrl}/api/yieldhistory/${assetClass}?reportControlId=${reportControlId}&reportDate=${reportDate}&showIndex=${showIndex}`
      );
      dispatch(loadSuccess(assetClassString, res));
    } catch (error) {
      return request.handleFetchError(dispatch, error, loadFail(assetClassString, error));
    }
  };
};
